import React, { useState } from 'react';
import { ExpandCollapseButton } from '@/components/staffer/ProgramResources/ExpandCollapseButton';
import { ModelResource, ProgramResourceIcon } from './ProgramResources.utils';
import { ProgramResourceCard } from './ProgramResourceCard';

interface ProgramResourcesProps {
  iconMapping: Record<number, ProgramResourceIcon>;
  resources: ModelResource[];
}

export function ProgramResources({ iconMapping, resources }: ProgramResourcesProps) {
  const [allExpanded, setAllExpanded] = useState(true);

  return (
    <>
      <div className="tw-w-full tw-h-[1px] tw-bg-[#eee] tw-my-4" />
      <ExpandCollapseButton isExpanded={allExpanded} onToggle={() => setAllExpanded(!allExpanded)} />
      <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-4">
        {resources.map(resource => (
          <ProgramResourceCard
            key={`resource-${resource.id}-${allExpanded}`}
            defaultIsOpen={allExpanded}
            iconMapping={iconMapping}
            resource={resource}
          />
        ))}
      </div>
    </>
  );
}
